import { Button, cn } from '@heroui/react';
import { IconEdit, IconMenu } from '@tabler/icons-react';

export type AiChatHeaderProps = {
  className?: string;
  onOpenHistory: () => void;
  onNewSession?: () => void;
  showNewSession?: boolean;
};

export function AiChatHeader({
  className,
  onOpenHistory,
  onNewSession,
  showNewSession = true,
}: AiChatHeaderProps) {
  return (
    <header
      className={cn(
        'border-border/60 flex h-12 shrink-0 items-center gap-1 border-b px-3',
        className
      )}
    >
      <Button
        isIconOnly
        aria-label="打开会话记录"
        className="text-foreground"
        size="sm"
        variant="ghost"
        onPress={onOpenHistory}
      >
        <IconMenu className="size-5" stroke={1.75} />
      </Button>
      {showNewSession ? (
        <Button
          isIconOnly
          aria-label="新建会话"
          className="text-foreground"
          size="sm"
          variant="ghost"
          onPress={onNewSession}
        >
          <IconEdit className="size-5" stroke={1.75} />
        </Button>
      ) : null}
    </header>
  );
}
